export default __webpack_public_path__ + "img/ZIIJsDbr.0fdb935e.svg";